var cov_1kidmdx12p = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Modal/Modal.tsx",
      hash = "40b3d0f2527cf387ed08828473079d7f34d18309",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Modal/Modal.tsx",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 21
        },
        end: {
          line: 15,
          column: 1
        }
      },
      "1": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 16
        }
      },
      "2": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 25
        }
      },
      "3": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 32
        }
      },
      "4": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 52
        }
      },
      "5": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 52,
          column: 5
        }
      },
      "6": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 35
        }
      },
      "7": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 57
        }
      },
      "8": {
        start: {
          line: 56,
          column: 45
        },
        end: {
          line: 56,
          column: 57
        }
      },
      "9": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 38
        }
      },
      "10": {
        start: {
          line: 57,
          column: 27
        },
        end: {
          line: 57,
          column: 38
        }
      },
      "11": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 60
        }
      },
      "12": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 68
        }
      },
      "13": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 65,
          column: 5
        }
      },
      "14": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 64,
          column: 35
        }
      },
      "15": {
        start: {
          line: 69,
          column: 26
        },
        end: {
          line: 69,
          column: 36
        }
      },
      "16": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 26
        }
      },
      "17": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 32
        }
      },
      "18": {
        start: {
          line: 75,
          column: 55
        },
        end: {
          line: 75,
          column: 65
        }
      },
      "19": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 81,
          column: 5
        }
      },
      "20": {
        start: {
          line: 85,
          column: 38
        },
        end: {
          line: 85,
          column: 48
        }
      },
      "21": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 40
        }
      },
      "22": {
        start: {
          line: 86,
          column: 22
        },
        end: {
          line: 86,
          column: 40
        }
      },
      "23": {
        start: {
          line: 90,
          column: 35
        },
        end: {
          line: 90,
          column: 45
        }
      },
      "24": {
        start: {
          line: 91,
          column: 19
        },
        end: {
          line: 91,
          column: 35
        }
      },
      "25": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 93,
          column: 55
        }
      },
      "26": {
        start: {
          line: 93,
          column: 30
        },
        end: {
          line: 93,
          column: 55
        }
      },
      "27": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 15
        }
      },
      "28": {
        start: {
          line: 98,
          column: 0
        },
        end: {
          line: 98,
          column: 35
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        loc: {
          start: {
            line: 42,
            column: 33
          },
          end: {
            line: 47,
            column: 3
          }
        },
        line: 42
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 49,
            column: 3
          }
        },
        loc: {
          start: {
            line: 49,
            column: 22
          },
          end: {
            line: 53,
            column: 3
          }
        },
        line: 49
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 55,
            column: 2
          },
          end: {
            line: 55,
            column: 3
          }
        },
        loc: {
          start: {
            line: 55,
            column: 40
          },
          end: {
            line: 60,
            column: 3
          }
        },
        line: 55
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        },
        loc: {
          start: {
            line: 62,
            column: 23
          },
          end: {
            line: 66,
            column: 3
          }
        },
        line: 62
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        },
        loc: {
          start: {
            line: 68,
            column: 25
          },
          end: {
            line: 72,
            column: 3
          }
        },
        line: 68
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 74,
            column: 3
          }
        },
        loc: {
          start: {
            line: 74,
            column: 23
          },
          end: {
            line: 82,
            column: 3
          }
        },
        line: 74
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        },
        loc: {
          start: {
            line: 84,
            column: 17
          },
          end: {
            line: 87,
            column: 3
          }
        },
        line: 84
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 89,
            column: 2
          },
          end: {
            line: 89,
            column: 3
          }
        },
        loc: {
          start: {
            line: 89,
            column: 11
          },
          end: {
            line: 95,
            column: 3
          }
        },
        line: 89
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }, {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }],
        line: 50
      },
      "1": {
        loc: {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 26
          }
        }, {
          start: {
            line: 50,
            column: 30
          },
          end: {
            line: 50,
            column: 51
          }
        }],
        line: 50
      },
      "2": {
        loc: {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 57
          }
        }, {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 57
          }
        }],
        line: 56
      },
      "3": {
        loc: {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 38
          }
        }, {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 38
          }
        }],
        line: 57
      },
      "4": {
        loc: {
          start: {
            line: 59,
            column: 11
          },
          end: {
            line: 59,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 59,
            column: 11
          },
          end: {
            line: 59,
            column: 47
          }
        }, {
          start: {
            line: 59,
            column: 51
          },
          end: {
            line: 59,
            column: 68
          }
        }],
        line: 59
      },
      "5": {
        loc: {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 65,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 65,
            column: 5
          }
        }, {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 65,
            column: 5
          }
        }],
        line: 63
      },
      "6": {
        loc: {
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 63,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 63,
            column: 26
          }
        }, {
          start: {
            line: 63,
            column: 30
          },
          end: {
            line: 63,
            column: 51
          }
        }],
        line: 63
      },
      "7": {
        loc: {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 86,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 86,
            column: 40
          }
        }, {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 86,
            column: 40
          }
        }],
        line: 86
      },
      "8": {
        loc: {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 93,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 93,
            column: 55
          }
        }, {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 93,
            column: 55
          }
        }],
        line: 93
      },
      "9": {
        loc: {
          start: {
            line: 93,
            column: 8
          },
          end: {
            line: 93,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 93,
            column: 8
          },
          end: {
            line: 93,
            column: 15
          }
        }, {
          start: {
            line: 93,
            column: 19
          },
          end: {
            line: 93,
            column: 28
          }
        }],
        line: 93
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import { Component } from 'react';
import { defaultProps } from '../utils/defaultProps';
import shallowEqual from '../utils/shallowEqual';
import { getUidStr } from '../utils/uid';
import { open, close, destroy } from './events';
var DefaultValue = (cov_1kidmdx12p.s[0]++, _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  usePortal: true,
  visible: false,
  hideMask: false,
  esc: true
}));

var Modal =
/*#__PURE__*/
function (_Component) {
  _inherits(Modal, _Component);

  var _super = _createSuper2(Modal);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    cov_1kidmdx12p.f[0]++;
    cov_1kidmdx12p.s[1]++;
    _this = _super.call(this, props);
    _this.id = void 0;
    _this.visible = void 0;
    cov_1kidmdx12p.s[2]++;
    _this.id = getUidStr();
    cov_1kidmdx12p.s[3]++;
    _this.visible = props.visible;
    cov_1kidmdx12p.s[4]++;
    _this.handleUpdate = _this.handleUpdate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_1kidmdx12p.f[1]++;
      cov_1kidmdx12p.s[5]++;

      if ((cov_1kidmdx12p.b[1][0]++, this.props.visible) && (cov_1kidmdx12p.b[1][1]++, !this.props.usePortal)) {
        cov_1kidmdx12p.b[0][0]++;
        cov_1kidmdx12p.s[6]++;
        open(this.getOption(), false);
      } else {
        cov_1kidmdx12p.b[0][1]++;
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      cov_1kidmdx12p.f[2]++;
      cov_1kidmdx12p.s[7]++;

      if (shallowEqual(this.props, nextProps)) {
        cov_1kidmdx12p.b[2][0]++;
        cov_1kidmdx12p.s[8]++;
        return false;
      } else {
        cov_1kidmdx12p.b[2][1]++;
      }

      cov_1kidmdx12p.s[9]++;

      if (nextProps.visible) {
        cov_1kidmdx12p.b[3][0]++;
        cov_1kidmdx12p.s[10]++;
        return true;
      } else {
        cov_1kidmdx12p.b[3][1]++;
      }

      cov_1kidmdx12p.s[11]++;
      close(_objectSpread2(_objectSpread2({}, this.props), {}, {
        id: this.id
      }), this.handleUpdate);
      cov_1kidmdx12p.s[12]++;
      return (cov_1kidmdx12p.b[4][0]++, !shallowEqual(this.props, nextProps)) && (cov_1kidmdx12p.b[4][1]++, nextProps.visible);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      cov_1kidmdx12p.f[3]++;
      cov_1kidmdx12p.s[13]++;

      if ((cov_1kidmdx12p.b[6][0]++, this.props.visible) && (cov_1kidmdx12p.b[6][1]++, !this.props.usePortal)) {
        cov_1kidmdx12p.b[5][0]++;
        cov_1kidmdx12p.s[14]++;
        open(this.getOption(), false);
      } else {
        cov_1kidmdx12p.b[5][1]++;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_1kidmdx12p.f[4]++;

      var _ref = (cov_1kidmdx12p.s[15]++, this.props),
          usePortal = _ref.usePortal;

      cov_1kidmdx12p.s[16]++;
      close({
        id: this.id
      });
      cov_1kidmdx12p.s[17]++;
      destroy(this.id, !usePortal);
    }
  }, {
    key: "getOption",
    value: function getOption() {
      cov_1kidmdx12p.f[5]++;

      var _ref2 = (cov_1kidmdx12p.s[18]++, this.props),
          children = _ref2.children,
          usePortal = _ref2.usePortal,
          visible = _ref2.visible,
          props = _objectWithoutProperties(_ref2, ["children", "usePortal", "visible"]);

      cov_1kidmdx12p.s[19]++;
      return _objectSpread2(_objectSpread2({}, props), {}, {
        content: children,
        id: this.id,
        from: 'modal' // overwrite props from

      });
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate() {
      cov_1kidmdx12p.f[6]++;

      var _ref3 = (cov_1kidmdx12p.s[20]++, this.props),
          destroyProps = _ref3.destroy;

      cov_1kidmdx12p.s[21]++;

      if (destroyProps) {
        cov_1kidmdx12p.b[7][0]++;
        cov_1kidmdx12p.s[22]++;
        this.forceUpdate();
      } else {
        cov_1kidmdx12p.b[7][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_1kidmdx12p.f[7]++;

      var _ref4 = (cov_1kidmdx12p.s[23]++, this.props),
          usePortal = _ref4.usePortal,
          visible = _ref4.visible;

      var option = (cov_1kidmdx12p.s[24]++, this.getOption());
      cov_1kidmdx12p.s[25]++;

      if ((cov_1kidmdx12p.b[9][0]++, visible) && (cov_1kidmdx12p.b[9][1]++, usePortal)) {
        cov_1kidmdx12p.b[8][0]++;
        cov_1kidmdx12p.s[26]++;
        return open(option, true);
      } else {
        cov_1kidmdx12p.b[8][1]++;
      }

      cov_1kidmdx12p.s[27]++;
      return null;
    }
  }]);

  return Modal;
}(Component);

Modal.defaultProps = DefaultValue;
Modal.displayName = void 0;
Modal.info = void 0;
Modal.warn = void 0;
Modal.error = void 0;
Modal.confirm = void 0;
Modal.show = void 0;
Modal.success = void 0;
Modal.closeAll = void 0;
Modal.Submit = void 0;
cov_1kidmdx12p.s[28]++;
Modal.displayName = 'ShineoutModal';
export default Modal;